export enum ProductCTAConstants {
  OUT_OF_STOCK = 'Out of Stock',
  BACK_IN_STOCK = 'Back in Stock after',
  ADD_TO_CART = 'ADD TO CART',
  SHOP_SIMILAR = 'SHOP SIMILAR',
  JOIN_WAITLIST = 'JOIN WAITLIST',
  WAITLISTED = 'WAITLISTED',
  ITEM_NO_LONGER_AVAILABLE = 'This item is no longer available',
}
